import { Box, Container, Grid, Text, Title, useMantineTheme, ScrollArea } from '@mantine/core';
import { useElementSize, useMediaQuery } from '@mantine/hooks';

const TermsConditions = () => {
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const { ref, height } = useElementSize();

  return (
    <>
      <Container>
        <div ref={ref}>
          <Grid m={0} pb={5}>
            <Grid.Col span={3} mt={-5} ta='left'>
              <Text fz='16px' fw={500} color='black'>
                TERMS & CONDITIONS
              </Text>
            </Grid.Col>
          </Grid>
        </div>

        <ScrollArea.Autosize type='never' mah={window.innerHeight - (height + 90)}>
          <Box pt='30px' pl='10px'>
            <Title align='left' fz={mobile ? '16px' : '18px'} fw={500} color='black'>
              Effective Date: June 15, 2023
            </Title>
            <Text align='left' pt='20px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              Please read these Terms and Conditions ("Agreement") carefully before accessing or using the Clamor
              website ("Site") and the services provided by Clamor ("Services"). This Agreement sets forth the legally
              binding terms and conditions for your use of the Site and Services.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              1. Acceptance of Terms
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              By accessing or using the Site and Services, you agree to be bound by this Agreement. If you do not agree
              with any part of this Agreement, you must not use the Site or Services.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              2. User Accounts
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              2.1 Restaurant Customer Accounts: Restaurant customers do not need to create an account to place orders.
              However, they are required to provide either a phone number or an email for verification purposes using a
              one-time password (OTP). By providing this information, you consent to receiving communication from Clamor
              for order-related notifications.
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              2.2 Restaurant Owner Accounts: Restaurant owners are required to create an account on the Site. During the
              account creation process, restaurant owners must provide necessary billing and identity information to set
              up their restaurant. This information may include bank account details for direct deposit and
              government-issued identification for identity verification. By creating an account, restaurant owners
              authorize Clamor to use the provided information for the purpose of providing the Services.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              3. Payment and Refunds
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.1 Payment Processing: Payments for Clamor's Services are processed using an industry-leading third-party
              payment processing service, Stripe. By using the Services, you agree to comply with Stripe's terms and
              conditions and privacy policy.
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.2 Fees:
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.2.1 Restaurant Customers: Clamor does not charge any fees to restaurant customers for using the
              Services. However, standard charges from your internet service provider or mobile carrier may apply for
              data usage.
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.2.2 Restaurant Owners: Restaurant owners are responsible for paying fees associated with using Clamor's
              Services. These fees include standard credit card processing fees and a subscription fee, which will be
              detailed during the sign-up process. Clamor reserves the right to modify the fees with prior notice.
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.3 Refunds and Disputes:
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.3.1 Restaurant Customers: If a restaurant customer wishes to request a refund or dispute a charge, they
              should contact Clamor support at &nbsp;
              <a style={{ textDecoration: 'none', color: 'black' }} href='mailto:info@clamortogo.com'>
                [info@clamortogo.com].
              </a>
              &nbsp; Clamor will review the request and work with the involved parties to resolve the issue in a fair
              and timely manner.
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              3.3.2 Restaurant Owners: Refund and dispute processes for restaurant owners will be outlined in separate
              agreements between Clamor and the restaurant owners. Please refer to the specific agreement for details
              regarding refunds and disputes.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              4. User Obligations
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              By using the Site and Services, you represent and warrant that you are of legal age and have the legal
              capacity to enter into this Agreement. You agree to use the Site and Services only for lawful purposes and
              in compliance with all applicable laws and regulations. You further agree not to engage in any fraudulent,
              deceptive, or misleading activities or violate any intellectual property rights of Clamor or any third
              party.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              5. Intellectual Property Rights
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              The Site and Services, including all content, trademarks, logos, and designs, are the intellectual
              property of Clamor or its licensors. You acknowledge and agree that you will not use, copy, modify,
              distribute, or reproduce any part of the Site or Services without the prior written consent of Clamor.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              6. Disclaimer of Warranties
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              The Site and Services are provided on an "as-is" and "as available" basis without any warranties or
              representations of any kind, whether express, implied, or statutory. Clamor does not warrant that the Site
              or Services will be uninterrupted, error-free, or secure. Clamor disclaims all warranties, including but
              not limited to the warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              7. Limitation of Liability
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              To the maximum extent permitted by law, Clamor shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, including but not limited to loss of profits, data, or goodwill,
              arising out of or in connection with the use or inability to use the Site or Services, even if Clamor has
              been advised of the possibility of such damages.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              8. Governing Law and Jurisdiction
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              This Agreement shall be governed by and construed in accordance with the laws of the United States,
              without regard to its conflict of law principles. Any dispute arising out of or in connection with this
              Agreement shall be submitted to the exclusive jurisdiction of the courts of the United States.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              9. Severability
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              If any provision of this Agreement is held to be invalid, illegal, or unenforceable, the remaining
              provisions shall continue in full force and effect.
            </Text>
            <Text align='left' pt={10} fz={mobile ? '11px' : '13px'} fw={450} color='black'>
              10. Entire Agreement
            </Text>
            <Text align='left' pt='5px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              This Agreement constitutes the entire agreement between you and Clamor regarding the Site and Services and
              supersedes any prior or contemporaneous agreements, communications, or understandings, whether oral or
              written.
            </Text>

            <Text align='left' pt='10px' fw={450} fz={mobile ? '11px' : '13px'} color='black'>
              By accessing or using the Clamor website and services, you acknowledge that you have read, understood, and
              agreed to be bound by this Agreement.
            </Text>

            <Text fw={450} align='left' pt='10px' pb={20} fz={mobile ? '11px' : '13px'} color='black'>
              If you have any questions or concerns regarding these Terms and Conditions, please contact us at &nbsp;
              <a style={{ textDecoration: 'none', color: 'black' }} href='mailto:info@clamortogo.com'>
                [info@clamortogo.com].
              </a>
            </Text>
          </Box>
        </ScrollArea.Autosize>
      </Container>
    </>
  );
};

export default TermsConditions;
